define('app/visualizations/GridView',['require','glu/layout','glu/collection','glu/util','glu/grid/gridLayout','glu/itemView','glu/grid/column/columnHeader','hbs!./GridHeaderView.hbs','app/visualizations/FormatFactory','glu/dialog','app/models/Report','app/models/CompoundFilter','app/editor/dialogs/DomainReportDialogView','app/app','hbs!./GridView.hbs'],function(require) {
	'use strict';

	var Layout = require('glu/layout'),
		Collection = require('glu/collection'),
		_ = require('glu/util'),
		Grid = require('glu/grid/gridLayout'),
		ItemView = require('glu/itemView'),
		ColumnHeader = require('glu/grid/column/columnHeader'),
		GridHeaderView = require('hbs!./GridHeaderView.hbs'),
		FormatFactory = require('app/visualizations/FormatFactory'),
		Dialog = require('glu/dialog'),
		Report = require('app/models/Report'),
		CompoundFilter = require('app/models/CompoundFilter'),
		DomainReportDialogView = require('app/editor/dialogs/DomainReportDialogView'),
		APP = require('app/app'),
		tmpl = require('hbs!./GridView.hbs');

	var openReports = APP.openReports;

	return Layout.extend({
		template: tmpl,

		regions: {
			'gridView': '#grid-view'
		},

		initialize: function() {
			var self = this;

			this.HeaderView = ColumnHeader.extend({
				initialize: function() {
					var report = self.model,
						col = this.model;

					if (!report.isGroupedAndAggregated()) {
						if (this.model.get('metadata').isMeasure) {
							this.model.set('columnTypeClass', ' measure');
						} else {
							this.model.set('columnTypeClass', ' dimension');
						}
					} else {
						if (this.model.get('metadata').aggregation) {
							this.model.set('columnTypeClass', ' aggregate');
						} else {
							this.model.set('columnTypeClass', ' group');
						}
					}
					var isFilter = _.filter(report.filter().filterCollection().models, function(filter) {
						if (filter.get('fieldObject')) {
							return filter.get('fieldObject').id === col.get('metadata').fieldId;
						} else {
							return filter.get('segmentId') === col.get('metadata').segmentId || filter.get('function') === col.get('metadata').function;
						}
					}).length > 0;

					if (isFilter) {
						this.model.set('isFilter', true);
					}

					this.listenTo(this, 'reorder', function() {
						self.model.trigger('change:reorder', self.updateColumnOrder());
					});
				},

				getTemplate: function() {
					return GridHeaderView;
				}
			});

			this.DrillDownCellView = ItemView.extend({
				tagName: 'td',
				serializeData: function() {
					return this;
				},
				events: {
					'click button': 'reportClick'
				},
				reportClick: function() {
					var rawValue = this.model.get(this.options.column.get('field'));
					self.drillDown(this.model, this.options.column, rawValue);
				},
				value: function() {
					var column = this.options.column;
					var format = column.get('format') || _.identity;
					return format(this.model.escape(column.get('field')));
				},
				template: function(view) {
					return '&nbsp;<button class="grid-drill-down-button">' + view.value() + '</button>';
				},
				className: function() {
					return this.options.column.get('className');
				}
			});

			this.DetailsCellView = ItemView.extend({
				tagName: 'td',
				serializeData: function() {
					return this;
				},
				events: {
					'click button': 'reportClick'
				},
				reportClick: function() {
					var rawValue = this.model.get(this.options.column.get('field'));
					self.domainReport(this.model, this.options.column, rawValue);
				},
				value: function() {
					var column = this.options.column;
					var format = column.get('format') || _.identity;
					return format(this.model.escape(column.get('field')));
				},
				template: function(view) {
					return '&nbsp;<button class="grid-drill-down-button">' + view.value() + '</button>';
				},
				className: function() {
					return this.options.column.get('className');
				}
			});

			this.columns = new Collection();
			this.collection = new Collection();
		},

		activate: function() {
			var self = this;

			self.attachListeners();

			if (!this.isRendered) {
				self.refreshResults();
				this.isRendered = true;
				self.$el.removeClass('is-loading');
				self.$el.find('.loading-indicator').remove();
			}
		},

		onShow: function() {
			this.activate();
		},

		onClose: function() {
			this.collection.reset();
		},

		attachListeners: function() {
			var self = this;
			var report = this.model;

			self.listenTo(this.model, 'dataReceived', function() {
				self.refreshResults();
				self.$el.removeClass('is-loading');
				self.$el.find('.loading-indicator').remove();
			});

			self.listenTo(self.columns, 'change:width', function() {
				self.columns.each(function(column, index) {
					if (self.isInitalizingWidths) {
						return;
					}
					report.setOption('columnWidth:' + index, column.get('width'));
				});
			});

			window.setTimeout(function() {
				self.listenTo(self.columns, 'change:width', function() {
					report.trigger('change');
				});
			}, 2000);

			self.listenTo(self.columns, 'change:sorted', function(column, direction) {
				var index = column.collection.indexOf(column);
				report.sortColumn(column.get('metadata'), direction);
				report.consumableResults().sort(index, direction);
				self.model.trigger('change:sorted');
				if (report.results().isMoreRowsAvailable) {
					_.defer(function() {
						report.run();
					});
				} else {
					_.defer(function() {
						self.addMoreRowsWarning();
					});
				}
			});

			// display a loading indicator whenever a report is run
			self.listenTo(report, 'run', function() {
				self.$el.addClass('is-loading');

				// ensure self icon is only displayed once
				if (!self.$el.find('.loading-indicator').length) {
					self.$el.append('<div class="loading-indicator">Loading&hellip;</div>');
				}
			});
		},

		updateColumnOrder: function() {
			var self = this;
			var newCollection = [];
			var i = 0;

			var findColumn = function(col) {
				if (col.get('function')) {
					return self.columns.models[i].get('metadata').function === col.get('function') &&
						self.columns.models[i].get('metadata').name === col.get('name') &&
						self.columns.models[i].get('metadata').isPercentage === col.get('isPercentage') &&
						self.columns.models[i].get('metadata').aggregation === col.get('aggregation');
				} else {
					return self.columns.models[i].get('metadata').fieldId === col.get('fieldId') &&
						self.columns.models[i].get('metadata').segmentId === col.get('segmentId') &&
						self.columns.models[i].get('metadata').isPercentage === col.get('isPercentage') &&
						self.columns.models[i].get('metadata').aggregation === col.get('aggregation');
				}
			};


			for (i = 0; i < this.columns.models.length; i++) {
				var match = _.find(this.model.get('columnCollection').models, findColumn);
				this.model.get('columnCollection').remove(match);
				if (match) {
					newCollection.push(match);
				}
			}

			this.model.get('columnCollection').reset(newCollection);
			this.model.trigger('change');
		},

		refreshResults: function() {
			var report = this.model;
			var gridResults = report.consumableResults();
			var self = this;

			if (gridResults) {
				self.columns.reset(gridResults.columns());
				self.collection.reset(gridResults.rows());

				if (report.attributes.options) {
					var reportOptions = JSON.parse(JSON.stringify(report.attributes.options));

					self.columns.each(function(column, i) {
						var width = reportOptions['columnWidth:' + i];

						if (width) {
							column.set('width', width);
						}
					});
				}

				self.columns.each(function(column) {
					column.set('label', self.generateLabel(column, report.results().isMoreRowsAvailable));

					// Disable primary key columns
					var showColumn = column.get('metadata').name && column.get('metadata').name !== 'primaryColumn';
					// Using "column.set('condition', showColumn)" causes IE to break for an unknown reason
					column.attributes.condition = showColumn;
				});

				self.columns.last().set('width', 'auto');

				self.columns.each(function(column) {
					if (self.model.isGroupedAndAggregated()) {
						column.set('cellView', self.DrillDownCellView);
					} else {
						column.set('cellView', self.DetailsCellView);
					}
					column.set('headerView', self.HeaderView);
				});

				self.addMoreRowsWarning();

				this.gridView.show(new Grid({
					filter: false,
					paginate: 'advanced',
					pageSize: 50,
					defaultColumnWidth: 'auto',
					collection: this.collection,
					columns: this.columns,
					resizable: true,
					disableDynamicColumnWidths: true,
					stickyFooter: true
				}));
				report.trigger('gridRendered');
			}
		},

		generateLabel: function(column, partialResult) {
			var output, total, formatter, aggregation, displayType;

			output = column.get('label');
			total = column.get('metadata').total;
			aggregation = column.get('metadata').aggregation;
			displayType = column.get('metadata').displayType;

			formatter = FormatFactory.formatterForType(column.get('metadata').type, {
				'aggregation': aggregation,
				'displayType': displayType
			});

			if (!partialResult) {
				if (!isNaN(total) && (!aggregation || aggregation === 'SUM' || aggregation === 'COUNT' || aggregation === 'COUNTD')) {
					if (column.get('metadata').fieldType === 'DATE' || column.get('metadata').fieldType === 'DATETIME') {
						return output + ' (' + total + ')';
					}
				}

				if (!isNaN(total) && (!aggregation || aggregation === 'SUM' || aggregation === 'COUNT' || aggregation === 'COUNTD')) {
					return output + ' (' + formatter(total) + ')';
				} else {
					return output;
				}
			} else {
				return output;
			}
		},

		addMoreRowsWarning: function() {
			var self = this;
			if (this.model.results().isMoreRowsAvailable) {
				_.defer(function() {
					// ensure this icon is only displayed once
					if (!self.$el.find('.info .icon-warning').length) {
						self.$el.find('.info').append('<span class="icon-warning warning more-rows-warning" title="More records available, but not returned. Please adjust query or filter parameters to retrieve smaller result set"></span>');
					}
				});
			}
		},

		storeColumnArrangement: function() {
			var report = this.model;
			var headers = [];
			this.grid.columns.each(function(c, i) {
				report.setColumnArrangement(c.get('metadata'), i);
				headers.push(c.get('metadata'));
			});
			this.model.consumableResults().rearrangeHeaders(headers);

		},

		drillDown: function(row) {
			var self = this;
			var rolledUpFields = row.get('rolledUpFields');
			var report = this.model.clone();
			report.unset('id');

			_.each(rolledUpFields, function(f) {
				if (f.fieldId) {
					report.addFieldEqualsValueFilter(f.fieldId, f.value);
				} else if (f.segmentId) {
					report.addFieldEqualsValueSegmentFilter(f, f.value);
				} else if (f.function) {
					report.addFieldEqualsValueFunctionFilter(f, f.value);
				}
			});

			report.setGroupedAndAggregated(false);
			report.addSpdColumns();
			report.setName('Drill Down: ' + report.getName());
			report.setUrlOrigin(window.location.pathname);
			openReports.add(report);

			self.navigateTo('/domains/' + report.getDomainId() + '/unsaved-report/' + report.cid);
		},

		domainReport: function(row) {
			var self = this,
				domain = self.model.get('domain'),
				domainReport = domain.get('domainReport'),
				columnVisualOptions = [];

			if (domainReport.visual && domainReport.visual.options && domainReport.visual.options.columns) {
				columnVisualOptions = JSON.parse(domainReport.visual.options.columns);
			}

			var report = new Report({
				name: domainReport.name,
				description: domainReport.description,
				domainId: domainReport.domainId,
				domain: domain,
				owner: APP.user.getUsername(),
				filter: new CompoundFilter({
					operator: 'AND',
					filterCollection: new Collection()
				})
			});

			domainReport.filters.operands[0].operands[1].val = row.get('column_primaryColumn');

			// Add columns
			for (var i = 0; i < domainReport.columns.length; i++) {
				var colVisualOptions;
				var col = domain.buildColumn({
					fieldId: domainReport.columns[i].fieldId
				});

				for (var l = 0; l < columnVisualOptions.length; l++) {
					var c = columnVisualOptions[l];
					if (c.fieldId === domainReport.columns[i].fieldId && c.aggregation === domainReport.columns[i].aggregation) {
						colVisualOptions = c;
					}
				}

				col.setAggregation(domainReport.columns[i].aggregation);
				col.setAsName(domainReport.columns[i].asName);
				col.setIsHidden(domainReport.columns[i].isHidden);
				col.get('fieldObject').set('isGroup', domainReport.columns[i].isGroup);

				// Set percentage of necessary
				if (colVisualOptions) {
					col.setPercentage(colVisualOptions.isPercentage);
				}

				report.attributes.columnCollection.add(col);
			}

			// Add filters
			for (var k = 0; k < domainReport.filters.operands.length; k++) {
				var filter = domain.buildEmptyFilterForFieldId(domainReport.filters.operands[k].operands[0].fieldId);
				filter.setOperator(domainReport.filters.operands[k].operator);
				filter.setValue(0, domainReport.filters.operands[k].operands[1].val);

				report.filter().addFilter(filter);
			}

			// Add visual options
			for (var j in domainReport.visual.options) {
				if (domainReport.visual.options.hasOwnProperty(j)) {
					report.setOption(j, domainReport.visual.options[j]);
				}
			}
			report.setOrderingCols(false);
			report.run().then(function() {
				Dialog.open(new DomainReportDialogView({
					model: report
				}));
			});
		}
	});

});

